import { Injectable } from '@angular/core';
import * as CryptoJS from "crypto-js";
@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }

  setItem(key: string, value: any) {
    var enc_key = CryptoJS.enc.Base64.parse("#base64Key#");
    var enc_iv = CryptoJS.enc.Base64.parse("#base64IV#");
    let storageKey_enc = CryptoJS.AES.encrypt(key, enc_key, { iv: enc_iv });
    let storageValue_enc = CryptoJS.AES.encrypt(JSON.stringify(value), enc_key, { iv: enc_iv });
    sessionStorage.setItem(storageKey_enc, storageValue_enc);
  }
  getItem(key: string): any {
    var enc_key = CryptoJS.enc.Base64.parse("#base64Key#");
    var enc_iv = CryptoJS.enc.Base64.parse("#base64IV#");
    let storageKey_enc = CryptoJS.AES.encrypt(key, enc_key, { iv: enc_iv });
    let storageValue_enc = sessionStorage.getItem(storageKey_enc);
    if (storageValue_enc) {
      let storageValue_dec = CryptoJS.AES.decrypt(storageValue_enc, enc_key, { iv: enc_iv }).toString(CryptoJS.enc.Utf8)
      if (storageValue_dec && storageValue_dec.length) {
        return JSON.parse(storageValue_dec);
      } else {
        return null;
      }
    }
    else {
      return null;
    }
  }
}
